import { AnnotatedResource } from "../resources/types";
import { WindowSize } from "../settings/types";
import { Theme } from "../themes/types";
import { MessageType } from "./constants";

const sendRendererMessage = (data: object) => {
  return new Promise(
    (resolve, reject) => {
      // BroadcastChannel doesn't work as the iframe is in a sandbox - we need to
      // rely on postMessage to its contentWindow.
      const iframe = document.getElementById('jw-renderer-frame') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        const channel = new MessageChannel();

        channel.port1.onmessage = (response) => {
          channel.port1.close();
          if (response.data.error) {
            reject(response.data.error);
          }else {
            resolve(response.data);
          }
        };

        iframe.contentWindow.postMessage(data, '*', [channel.port2]);
      }
    }
  );
};

export const requestRender = (resource: AnnotatedResource, theme: Theme, canvasSize: WindowSize) => {
  return sendRendererMessage({
    type: MessageType.RENDER_RESOURCE,
    resource,
    theme,
    canvasSize
  });
};
